<template>

  <div class="atividades-rfilancamentos ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->
              <b-col cols="6">
                <label for="select-garagem">Garagem</label>  
                <multiselect  v-model="value_garagem" required 
                  :options="garagens" 
                  :multiple="true" 
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a garagem" label="garagem" track-by="garagem" name="garagem"
                  :preselect-first="true">
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Garagem selecionada</span></template>
                </multiselect> 
              </b-col>

            <!--
              <b-col cols="4">
                <label for="input-live">Busca</label>  
                <b-form-input v-model="rfilancamento.motivo" required placeholder="Digite a linha"></b-form-input>              
              </b-col>
            -->
            

              <b-col cols="1">
                <br>                 
                <b-button variant="primary" class="mr-2 mt-2" :disabled="carregando" @click="loadLinhas()">
                  <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Pesquisar
                </b-button>                      
              </b-col>

            

              <b-col cols="1">
                <br>
                <b-button variant="warning" class="ml-5 mt-2" v-b-modal.modal-multi-2 >Novo</b-button>
              </b-col>

          </b-row>
    </b-form>

    
    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>    
    <!--tbl de dados -->
    <b-table id="linhalancamentos"  small hover striped sticky-header="550px"  :items="linhas" :fields="fields" >    
        <template slot="cell(actions)" slot-scope="data"  >

          <b-button @mouseup="loadEditLinha(data.item)" @click="cadastroLinha = !cadastroLinha,loadLinhas()" title="Tarefas"  size="sm" variant="success" class="mr-2">                
              <i class="fa fa-exclamation-circle"></i>
          </b-button>

        </template>   
        
    </b-table>

      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <div>        
    <b-modal id="modal-multi-2" v-model="cadastroLinha" cancel-title="Fechar"  ok-title="Gravar" @ok="postLinha(),reset(),loadLinhas()" @cancel="cadastroLinha = !cadastroLinha,reset()" hide-footer size="xl" title="Cadastro de Linhas"  no-close-on-esc no-close-on-backdrop>
          <!-- -->
          <div>

            <b-row>              
              <b-col cols="6">
              <label for="input-garagem">Garagem</label> 
              <div>                
                <b-form-select   
                  id="garagem"               
                  v-model="lin.id_filial"                    
                  required                                                   
                  :options="garagens"
                  class="mb-3 "
                  text-field="garagem"                                            
                >                
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="2"  class="mb-2">
                <label for="input-live">Nro da linha</label> 
                <b-form-input v-model="lin.linha" required placeholder="Nro linha"></b-form-input>              
              </b-col> 

            <b-col cols="2">
                <label for="input-linha">Lote</label> 
              <div>                
                <b-form-select    id="linhax"              
                  v-model="lin.id_lote" 
                  required                                                   
                  :options="lote"
                  class="mb-3 "
                  text-field="lote"                  
                > 
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="2"  class="mb-2">
                <label for="input-live">ID LINHA ERP</label> 
                <b-form-input v-model="lin.id_linha_erp" required placeholder="id_linha_erp"></b-form-input>              
            </b-col> 

            
            <b-col cols="6"  class="mb-2">
                <label for="input-live">Descrição da linha</label> 
                <b-form-input v-model="lin.denominacao" required placeholder="Digite a denominação da linha"></b-form-input>              
            </b-col>             

            <b-col cols="3">
              <label for="input-setor">Tipo da linha</label> 
              <div>                
                <b-form-select                  
                  v-model="lin.id_tipo"  
                  required                                                   
                  :options="tipo"
                  class="mb-3 "
                  text-field="tipo"                            
                >                
                </b-form-select>
              </div>
            </b-col> 

            <b-col cols="3">
              <label for="input-status">Status</label>  
              <div>                
                <b-form-select                  
                  v-model="lin.id_status"  
                  required                                                   
                  :options="status"
                  class="mb-3 "
                  text-field="status"                            
                >                
                </b-form-select>
              </div>
            </b-col> 


            <b-col cols="6">
              
              <label for="input-setor">Terminal Principal</label> 
              <div>                
                <b-form-select   id="tps"               
                  v-model="lin.id_ponto_tp"  
                  required                                                   
                  :options="tp"
                  class="mb-3 "
                  text-field="ponto"                   
                 @change="getpontp()" 
                >                
                </b-form-select>
              </div>
            </b-col> 

            <b-col cols="6">
              <label for="input-setor">Terminal Secundário</label>
              <div>                
                <b-form-select  id="tss"                
                  v-model="lin.id_ponto_ts"  
                  required                                                   
                  :options="ts"
                  class="mb-3 "
                  text-field="ponto"                            
                  @change="getponts()"
                >                
                </b-form-select>
              </div>
            </b-col> 
              
              <b-col cols="2">
                <label for="input-live">KM - G -> TP</label>
                <b-form-input id="gar_tp" v-model="lin.gar_tp" required placeholder="validar campo"></b-form-input>

              </b-col>

              <b-col cols="2">
                <label for="input-live">KM - G -> TS</label>
                <b-form-input id="gar_ts" 
                  v-model="lin.gar_ts" required  
                  placeholder="Ex.: 1,2"></b-form-input>                                              
              </b-col>

              <b-col cols="2">
                <label for="input-live">KM - TP -> TS</label>
                <b-form-input id="tp_ts" v-model="lin.tp_ts" required  placeholder="Ex.: 26,00"></b-form-input>                                              
              </b-col>

              <b-col cols="2">
                <label for="input-live">KM - TS -> TP</label>
                <b-form-input id="ts_tp" v-model="lin.ts_tp" required  placeholder="Ex.: 25,50"></b-form-input>                                              
              </b-col>

              <b-col cols="2">
                <label for="input-live">KM - TP -> G</label>
                <b-form-input id="tp_gar" v-model="lin.tp_gar" required  placeholder="Ex.: 1,1"></b-form-input>                                              
              </b-col>

              <b-col cols="2">
                <label for="input-live">KM - TS -> G</label>
                <b-form-input id="ts_gar" v-model="lin.ts_gar" required  placeholder="Ex.: 1,4"></b-form-input>                                              
              </b-col>
            </b-row> 


            <b-row class="mt-2">

              <b-col cols="4">
                <label for="input-live">Frota uteis</label> 
                <b-form-input 
                  id="frota_uteis"  
                  v-model="lin.frota_uteis" required  
                  placeholder="Ex.: 26">
                </b-form-input>                                              
              </b-col>

              <b-col cols="4">
                <label for="input-live">Frota sabado</label>
                <b-form-input 
                  id="frota_sabado"  
                  required 
                  v-model="lin.frota_sabado"                     
                  placeholder="Ex.: 22"></b-form-input>                                              
              </b-col>

              <b-col cols="4">
                <label for="input-live">Frota domingo</label>
                <b-form-input id="frota_domingo" required v-model="lin.frota_domingo"  placeholder="Ex.: 18"></b-form-input>                                              
              </b-col>

            </b-row> 
            
            <b-row   class=" mt-2 mb-2">          
            
              <b-col cols="6">
                <label for="input-live">Atraso em minutos</label>
                <b-form-input v-model="lin.atraso_minutos" required placeholder="tempo limite para não justificar atraso na partida"></b-form-input>              
              </b-col>

              <b-col cols="6"  class="mb-6">
                <label for="input-live">Antecedência em minutos</label>
                <b-form-input v-model="lin.antecedencia_registrar_ponto" required placeholder="tempo limite para registrar ponto"></b-form-input>              
              </b-col>            
             
            </b-row> 

             <b-button class="mt-3" variant="success" block  @click="postLinha()">Gravar</b-button>
            
          </div>
          
        </b-modal>
      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
  </div>  

  
  



</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment from 'moment'


export default {

  


    name: 'ManutencaoRfiLancamento',    



    data: function() {

      

        
      
        return {            
            mode: 'save',
            carregando: false,
            atualizando: false,            

            garagem:{}, 
            garagens: [],   // [] lista    
            lin:{},
            linhas:{},
            lote:[],
            tipo:[],            
            tp:[], 
            ptp:{},
            pts:{},  
            ts:[],            
            value_garagem:[],// [] lista                         
            status:[],
                                     
            rfilancamento:{},// [] lista   
            rfilancamentos:[],// [] lista
            carro:{},
            selected: null,
            
            value_carro:'',
            value_motivo: '',
            value_pecas:'',
            value_observacoes:'',
            

            //value_carro:'',   

            
            
          //  barra_inicial: 0,         
          //  barra_limite: 300000,
            
            fields: [                
                { key: 'id_linha', label: 'ID', sortable: true },                 
                { key: 'id_filial', label: 'Garagem', sortable: true },                 
                { key: 'linha', label: 'Nro Linha', sortable: true },                                
                
                
                { key: 'lote', label: 'Lote', sortable: true },
                { key: 'denominacao', label: 'Denominação', sortable: true },                                

                { key: 'tp', label: 'TP', sortable: true },                
                { key: 'ts', label: 'TS', sortable: true },                

            
                { key: 'frota_uteis', label: ' Frota Uteis', sortable: true },
                //{ key: 'frota_sabado', label: ' Frota Sab', sortable: true },
                //{ key: 'frota_domingo', label: ' Frota Dom', sortable: true },

                { key: 'atraso_minutos', label: 'Min Atraso', sortable: true },                
                { key: 'antecedencia_registrar_ponto', label: 'Min Antecedencia', sortable: true },                
                

               // { key: 'cadastrado_por', label: 'Cadastrado por', sortable: true },
               // { key: 'liberado_por', label: 'Liberado por', sortable: true },

               { key: 'dt_cadastro', label: 'Data Cadastro', sortable: true, formatter: (value, key, linhas) => {
                    return moment(linhas.dt_cadastro).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },

                
                { key: 'actions', label: 'Ações' },                
            ]
        }        
    },

    components: {
        Multiselect
    },


    methods: {

      //barra de progresso
      ready () {
      this.handle = setInterval(() =>{
        this.barra_inicial = this.barra_inicial + 1000
        if(this.barra_inicial >= this.barra_limite){
          this.barra_inicial = 0
          //this.loadRfiLancamentos()
        }
      },1000)
      },

      handleOk(bvModalEvent) {
        // Prevent modal from closing
        bvModalEvent.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },

      loadGaragens() {
          const url = `${baseApiUrl}/manutencao/rfi/garagem`  
          axios.get(url).then(res => {
            this.garagens = res.data.map(gar => {              
              return { ... gar, value:  gar.id_filial, garagem: gar.garagem }              
            })            
          })          
      },
      
      loadLinhas() {
            let corpo = {    
                "id_filial": `${[this.value_garagem.map(a => a.id_filial)]}`            
            };

          const url = `${baseApiUrl}/planejamento/linha/cad`
          return axios.post(url,corpo).then(res => {
             this.linhas = res.data.map(linha => {
              return { ... linha}
            })
          })          
        },

        async loadLote() {
          const url = `${baseApiUrl}/planejamento/linha/lote`
          return await axios.get(url).then(res => {
             this.lote = res.data.map(lot => {
               return { ... lot, value: lot.id_lote, lote: lot.lote}
            })
          })          
        },


        async loadLinhaTipo() {
          const url = `${baseApiUrl}/planejamento/linha/tipo`
          return await axios.get(url).then(res => {
             this.tipo = res.data.map(tipo => {
               return { ... tipo,  value: tipo.id_tipo, tipo: tipo.tipo}
            })
          })          
        },

        async loadLinhaStatus() {
          const url = `${baseApiUrl}/planejamento/linha/status`
          return await axios.get(url).then(res => {
             this.status = res.data.map(status => {
               return { ... status,  value: status.id_status, status: status.status}
            })
          })          
        },


        

        async loadTerminal() {
          const url = `${baseApiUrl}/planejamento/pontocad`
          return await axios.get(url).then(res => {
             this.tp = res.data.map(tp => {
               return { ... tp,  value: tp.id_ponto, ponto: tp.ponto}
            })
          })          
        },

        async loadTerminalTs() {
          const url = `${baseApiUrl}/planejamento/pontocad`
          return await axios.get(url).then(res => {
             this.ts = res.data.map(ts => {
               return { ... ts,  value: ts.id_ponto, ponto: ts.ponto}
            })
          })          
        },

        postLinha() {                        
        let corpo = { 
                
                "id_filial": `${this.lin.id_filial}`,
                "id_linha": `${this.lin.id_linha}`,
                "id_linha_erp": `${this.lin.id_linha_erp}`,
                "linha": `${this.lin.linha}`,
                "denominacao": `${this.lin.denominacao}`,  
                "id_tipo": `${this.lin.id_tipo}`,    
                "id_status": `${this.lin.id_status}`,    
                "id_ponto_tp": `${this.lin.id_ponto_tp}`,                              
                "id_ponto_ts": `${this.lin.id_ponto_ts}`,               
                "gar_tp": `${this.lin.gar_tp}`,
                "gar_ts": `${this.lin.gar_ts}`,
                "tp_ts": `${this.lin.tp_ts}`,
                "ts_tp": `${this.lin.ts_tp }`,
                "tp_gar": `${this.lin.tp_gar}`,
                "ts_gar": `${this.lin.ts_gar}`,
                "frota_uteis": `${this.lin.frota_uteis}`,
                "frota_sabado": `${this.lin.frota_sabado}`,
                "frota_domingo": `${this.lin.frota_domingo}`,
                "atraso_minutos": `${this.lin.atraso_minutos}`,
                "antecedencia_registrar_ponto": `${this.lin.antecedencia_registrar_ponto}`
        };

        const url = `${baseApiUrl}/planejamento/linha`   

            axios.post(url,corpo)
            .then(() => {     
                    this.postTp(),
                    this.postTs(),               
                    this.reset() //limpar os objetos valores
                    this.loadLinhas()
                    this.$toasted.global.defaultSuccess()
                })
                .catch(showError)
        },


        getpontp() {
          let corpo = {                
            "id_linha": `${this.lin.id_linha}`,                                                
            "id_sentido": `${1}`                              
          };

          const url = `${baseApiUrl}/planejamento/linha/gcadtp`
          axios.post(url,corpo).then(res => {
             this.ptp = res.data.map(ptp => {
              return { ... ptp, id_ponlin: ptp.id_ponlin}
            })
          })          
        },

        /////////////////////////////// cadastro tp
        postTp() {                        
        let corpo = {
              "id_ponlintp": `${this.ptp.map(tp => tp.id_ponlin)}`,            
                "id_filial": `${this.lin.id_filial}`,
                "id_linha": `${this.lin.id_linha}`,                                                
                "id_ponto_tp": `${this.lin.id_ponto_tp}`                              
        };

        const url = `${baseApiUrl}/planejamento/linha/cadtp`   
            axios.post(url,corpo)
            .then(() => {                  
                    //this.$toasted.global.defaultSuccess()
                })
                .catch(showError)
        },

        /////////////////////////////// cadastro ts
        getponts() {
          let corpo = {                
            "id_linha": `${this.lin.id_linha}`,                                                
            "id_sentido": `${2}`                              
          };

          const url = `${baseApiUrl}/planejamento/linha/gcadts`
          axios.post(url,corpo).then(res => {
             this.pts = res.data.map(pts => {
              return { ... pts, id_ponlin: pts.id_ponlin}
            })
          })          
        },

        /////////////////////////////// cadastro tp
        postTs() {                        
        let corpo = {
              "id_ponlints": `${this.pts.map(ts => ts.id_ponlin)}`,            
                "id_filial": `${this.lin.id_filial}`,
                "id_linha": `${this.lin.id_linha}`,                                                
                "id_ponto_ts": `${this.lin.id_ponto_ts}`                              
        };

        const url = `${baseApiUrl}/planejamento/linha/cadts`   
            axios.post(url,corpo)
            .then(() => {
                    //this.$toasted.global.defaultSuccess()
                })
                .catch(showError)
        },

        

        loadEditLinha(lin){            
            this.lin = { ...lin }
        },

        
      
        reset() {                  
            this.linha = {}          
            this.linhas = []      
            this.loadLinhas()
        }
      
      
       
    },
    
    mounted() {   
      this.loadLinhas() 
      this.getpontp()   
      this.getponts()         
      this.loadGaragens() 
      this.loadLinhaTipo() 
      this.loadLinhaStatus() 
      this.loadTerminal()
      this.loadTerminalTs()
      this.loadLote()
      this.loadEditLinha()
    },



}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

#selecaostatusx{
    font-size: 0.7em;      
}

#rfilancamentos{   
    font-size: 0.9em;      
    text-align: center;
    
}




</style>